import { Modal, ModalBody, ModalFooter, widthTypes } from "../Modal";
import { ReactNode } from "react";
import Button from "../../Buttons/Button";

export type ConfirmationModalProps = {
  title: string;
  cancelButtonText: string;
  confirmButtonText: string;
  onCancel: VoidFunction;
  onConfirm: VoidFunction;
  width?: widthTypes;
  confirmButtonDisabled?: boolean;
  cancelButtonDisabled?: boolean;
  fullWidthButtons?: boolean;
};

export type ConfirmationModalPropsWithChildren = {
  children: ReactNode;
  message?: never;
} & ConfirmationModalProps;

export type ConfirmationModalPropsWithMessage = {
  message: string;
  children?: never;
} & ConfirmationModalProps;

export const ConfirmationModal = (props: ConfirmationModalPropsWithChildren | ConfirmationModalPropsWithMessage) => {
  const {
    title,
    cancelButtonText,
    confirmButtonText,
    onCancel,
    onConfirm,
    width = "xs",
    confirmButtonDisabled = false,
    cancelButtonDisabled = false,
    fullWidthButtons = false,
  } = props;

  let bodyToRender: ReactNode;

  if ("children" in props) {
    bodyToRender = props.children;
  } else {
    bodyToRender = (
      <div className="h-20">
        <p className="pb-4">{props.message}</p>
      </div>
    );
  }

  const fullWidthButtonFooterClassName = fullWidthButtons ? "gap-4" : "";

  return (
    <Modal allowOverflow={true} title={title} width={width} close={() => { }} hideDismiss={true} color="inverted">
      <ModalBody>{bodyToRender}</ModalBody>
      <ModalFooter className={fullWidthButtonFooterClassName}>
        <Button text={confirmButtonText} disabled={confirmButtonDisabled} onClick={onConfirm} />
        <Button variant="text" text={cancelButtonText} disabled={cancelButtonDisabled} onClick={onCancel} />
      </ModalFooter>
    </Modal>
  );
};
